/* unplugin-vue-components disabled */import { render } from "./switch.vue?vue&type=template&id=7af0e01d&scoped=true&ts=true"
import script from "./switch.vue?vue&type=script&lang=ts"
export * from "./switch.vue?vue&type=script&lang=ts"

import "./switch.vue?vue&type=style&index=0&id=7af0e01d&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\17532\\Desktop\\智慧校园\\school-h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7af0e01d"]])

export default __exports__